












import { Vue, Component } from "@/shared/vuepack";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import MfaSettings from "@/shared/components/MfaSettings.vue";
import OktaFactorSettings from "@/shared/components/OktaFactorSettings.vue";

@Component({
  components: {
    MfaSettings,
    OktaFactorSettings
  }
})
export default class PartnerSecurity extends Vue {
  featureFlagStore = useFeatureFlagStore();

  get isOktaLoginEnabled () {
    return this.featureFlagStore.flags.bend23884EmpPortalOktaLogin;
  }
}
